var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.737,
    height: 19.583,
    viewBox: "0 0 14.737 19.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_29-kimono",
    "data-name": "29-kimono",
    transform: "translate(-5.9 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42733",
    "data-name": "Path 42733",
    d: "M26.162,26.218a1.216,1.216,0,0,1-.162-.6V24h.808v1.615a.4.4,0,0,0,.053.2Z",
    transform: "translate(-11.924 -14.309)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42734",
    "data-name": "Path 42734",
    d: "M20.567,26.221l-.7-.4a.4.4,0,0,0,.054-.2V24h.808v1.615A1.214,1.214,0,0,1,20.567,26.221Z",
    transform: "translate(-8.267 -14.309)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42735",
    "data-name": "Path 42735",
    d: "M18.634,14.672A3.638,3.638,0,0,1,15,11.037V10.23a.4.4,0,0,1,.262-.378,12.013,12.013,0,0,0,.965-2.559.4.4,0,0,1,.792.111,1.7,1.7,0,0,0,1.4,1.538,3.93,3.93,0,0,1-.189-1.134.4.4,0,0,1,.727-.242,3.986,3.986,0,0,0,2.907,1.454h.4A1.211,1.211,0,0,1,23.48,10.23v.338a1.615,1.615,0,0,1-1.1,1.534l-.3.1A3.64,3.64,0,0,1,18.634,14.672Zm-2.827-4.219v.585a2.827,2.827,0,1,0,5.653,0V9.807a4.477,4.477,0,0,1-2.181-.845c.065.17.117.277.119.28a.4.4,0,0,1-.361.584,2.96,2.96,0,0,1-2.4-1.138A5.115,5.115,0,0,1,15.808,10.452Zm6.461-.626v1.211c0,.081,0,.157-.008.234a.805.805,0,0,0,.411-.7V10.23A.4.4,0,0,0,22.268,9.826Z",
    transform: "translate(-5.366 -4.173)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42736",
    "data-name": "Path 42736",
    d: "M14.018,10.9a.4.4,0,0,1-.181-.042A3.594,3.594,0,0,1,12,7.672V4.846a4.846,4.846,0,1,1,9.691,0V6.461h-.808V4.846a4.038,4.038,0,1,0-8.076,0V7.672a2.812,2.812,0,0,0,.525,1.679,18.47,18.47,0,0,1-.121-2.083h.808a10.279,10.279,0,0,0,.361,3.05.4.4,0,0,1-.361.584Z",
    transform: "translate(-3.577 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42737",
    "data-name": "Path 42737",
    d: "M32.367,17.846a1.594,1.594,0,0,1-.808-.22,1.594,1.594,0,0,1-.808.22,1.615,1.615,0,0,1-1.523-1.077l.761-.269a.8.8,0,0,0,1.3.327.4.4,0,0,1,.54,0,.8.8,0,1,0,.747-1.373.4.4,0,0,1-.269-.54.8.8,0,0,0-.748-1.107V13a1.615,1.615,0,0,1,1.615,1.615,1.563,1.563,0,0,1-.015.213,1.612,1.612,0,0,1-.793,3.017Z",
    transform: "translate(-13.849 -7.751)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42738",
    "data-name": "Path 42738",
    d: "M34.615,42.827h-.808V40.808H33V40h1.211a.4.4,0,0,1,.4.4Z",
    transform: "translate(-16.097 -23.848)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42739",
    "data-name": "Path 42739",
    d: "M11.808,42.827H11V40.4a.4.4,0,0,1,.4-.4h7.672v.808H11.808Z",
    transform: "translate(-2.981 -23.848)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42740",
    "data-name": "Path 42740",
    d: "M20.133,34.884H6.4a.4.4,0,0,1-.4-.4V31.653a4.4,4.4,0,0,1,.888-2.665l.646.485a3.6,3.6,0,0,0-.727,2.181v2.423H19.729V31.653A3.638,3.638,0,0,0,16.1,28.019a.4.4,0,0,1-.383-.276l-.263-.792a52.211,52.211,0,0,0-5.1,5.369l-.613-.525C12,29.15,14.87,26,15.691,26a.4.4,0,0,1,.383.276l.315.944a4.448,4.448,0,0,1,4.147,4.433V34.48A.4.4,0,0,1,20.133,34.884Z",
    transform: "translate(0 -15.501)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42741",
    "data-name": "Path 42741",
    d: "M10.885,28.746,10.4,28.1a4.4,4.4,0,0,1,2.372-.879l.315-.944A.4.4,0,0,1,13.469,26c.162,0,.651,0,2.714,2.143l-.582.56a15.325,15.325,0,0,0-1.892-1.739l-.26.779a.4.4,0,0,1-.383.276A3.6,3.6,0,0,0,10.885,28.746Z",
    transform: "translate(-2.623 -15.501)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2858",
    "data-name": "Rectangle 2858",
    width: 6.003,
    height: 0.808,
    transform: "matrix(0.673, -0.74, 0.74, 0.673, 11.758, 16.284)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2859",
    "data-name": "Rectangle 2859",
    width: 0.808,
    height: 2.284,
    transform: "translate(10.157 12.4) rotate(-45)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimeIcon);
export default __webpack_public_path__ + "static/media/animeIcon.2ccf31b1a6b1cdb69554a8a1c15f09c3.svg";
export { ForwardRef as ReactComponent };